import {
  FilterInterfaceFilter,
  FormattingFilter,
  isReferenceLabelFormatting,
} from '@ardoq/api-types';
import { DEFAULT_MULTI_LABEL_REFERENCE_FORMATTING_FILTER_ATTRIBUTES } from '../consts';

export const getAllReferenceLabelFilters = (
  formattingFilters: (FormattingFilter | FilterInterfaceFilter)[]
): FilterInterfaceFilter[] => {
  const userDefinedFilters = formattingFilters.filter(
    isReferenceLabelFormatting
  );
  return userDefinedFilters.length > 0
    ? userDefinedFilters
    : DEFAULT_MULTI_LABEL_REFERENCE_FORMATTING_FILTER_ATTRIBUTES;
};
